/**
 * Query parameters for a write.
 *
 * ── What this used to do ─────────────────────────────────────────────────────
 *
 * Attach `?email=` to every write, because the API took the acting user from the
 * query string and trusted it. `created_by` and `posted_by` were whatever the
 * browser said. The header of this file promised that "when real auth arrives,
 * the `Authorization` header replaces `auth()` here and nothing else in the
 * application changes" — that is what happened, except the credential turned out
 * to be a cookie rather than a header, so there is nothing to attach at all.
 *
 * ── What it does now ─────────────────────────────────────────────────────────
 *
 * Nothing to the identity, and passes through whatever the call adds. The
 * session travels in an `HttpOnly` cookie that `fetch` sends on its own (see
 * `credentials: 'include'` in `api.ts`), and the server resolves the acting user
 * from it.
 *
 * The function is kept rather than deleted from thirty call sites, and kept
 * *typed the same*, so that the diff which removed the identity from the wire is
 * one file rather than thirty. It is also the place a future per-request header
 * — an idempotency key, a client version — would go, which is the other reason
 * not to inline `{}` everywhere.
 */

export function auth(
  extra: Record<string, string | undefined> = {},
): Record<string, string | undefined> {
  return extra;
}
